const TOPIC_VALUES = [
  "buergermeisterwahl",
  "wahlkampf",
  "personalratswahl",
  "politische-kommunikation",
  "verbandskommunikation",
  "gemeindekommunikation",
  "krisenkommunikation",
  "sonstiges",
] as const;

const TOPIC_LABELS: Record<(typeof TOPIC_VALUES)[number], string> = {
  buergermeisterwahl: "Bürgermeisterwahl",
  wahlkampf: "Wahlkampf",
  personalratswahl: "Personalratswahl",
  "politische-kommunikation": "Politische Kommunikation",
  verbandskommunikation: "Verbandskommunikation",
  gemeindekommunikation: "Gemeindekommunikation",
  krisenkommunikation: "Krisenkommunikation",
  sonstiges: "Sonstiges",
};

export const CONTACT_TOPICS = TOPIC_VALUES;
export const CONTACT_TOPIC_LABELS = TOPIC_LABELS;

export type ContactTopic = (typeof TOPIC_VALUES)[number];